const caixaEntradaGO = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Caixa de entrada',
        icon: null,
        link: null,
        codigo: 'CAIXA_ENTRADA',
    },
];

const validacaoAnaliseGO = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Validação da proposta',
        icon: null,
        link: null,
        codigo: 'VALIDACAO_PROPOSTA',
    },
];

const analiseProposta = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/analise-proposta',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Caixa de entrada',
        icon: null,
        link: '/analise-proposta',
        codigo: 'ANALISE_PROPOSTA',
    },
];

const analiseTecnica = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/analise-proposta',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Caixa de entrada',
        icon: null,
        link: '/analise-proposta',
        codigo: 'ANALISE_PROPOSTA',
    },
    {
        label: 'Análise técnica',
        icon: null,
        link: null,
        codigo: 'ANALISE_TECNICA',
    },
];

const regiaoAnalise = {
    listagem: [
        {
            label: null,
            icon: 'mdi-home',
            link: '/',
            codigo: 'PAGINA_INICIAL',
        },
        {
            label: 'Regiões de análise',
            icon: null,
            link: null,
            codigo: 'REGIAO_ANALISE',
        },
    ],

    cadastro: [
        {
            label: null,
            icon: 'mdi-home',
            link: '/',
            codigo: 'PAGINA_INICIAL',
        },
        {
            label: 'Regiões de análise',
            icon: null,
            link: '/regiao',
            codigo: 'REGIAO_ANALISE',
        },
        {
            label: 'Cadastrar/editar',
            icon: null,
            link: null,
            codigo: 'CADASTRO_REGIAO_ANALISE',
        },
    ],
};

const termoCompromisso = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Termo de Compromisso',
        icon: null,
        link: 'termo-compromisso',
        codigo: 'TERMO_COMPROMISSO',
    },
];

const consultarProcessos = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Consultar processos',
        icon: null,
        link: 'consultar-processos',
        codigo: 'CONSULTAR_PROCESSOS',
    },
];

const reanaliseProposta = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Em Reanálise',
        icon: null,
        link: 'reanalise-proposta',
        codigo: 'REANALISE-PROPOSTA',
    },
];

const analiseHistorico = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Histórico da Análise',
        icon: null,
        link: 'analise-historico',
        codigo: 'ANALISE_HISTORICO',
    },
];

const tipoDocumento = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Tipos de Documentos',
        icon: null,
        link: 'tipo-documento',
        codigo: 'TIPO_DOCUMENTO',
    },
];

const migracaoProcessos = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Migração de Processos',
        icon: null,
        link: 'migracao-processos',
        codigo: 'MIGRACAO_PROCESSOS',
    },
];

const analiseProcesso = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Análise',
        icon: null,
        link: 'analise-vinculo',
        codigo: 'ANALISE_VINCULO',
    },
];

const monitoramentoPrada = [
    {
        label: null,
        icon: 'mdi-home',
        link: '/caixa-entrada',
        codigo: 'PAGINA_INICIAL',
    },
    {
        label: 'Monitoramento Prada',
        icon: null,
        link: 'monitoramento-[rada',
        codigo: 'MONITORAMENTO_PRADA',
    },
];

export {
    caixaEntradaGO,
    validacaoAnaliseGO,
    regiaoAnalise,
    analiseTecnica,
    analiseProposta,
    termoCompromisso,
    consultarProcessos,
    reanaliseProposta,
    analiseHistorico,
    tipoDocumento,
    migracaoProcessos,
    analiseProcesso,
    monitoramentoPrada,
};
